import { FunctionComponent } from 'react'
import styles from './Backdrop.module.sass'

export const Backdrop: FunctionComponent = () => {
	return <div className={styles.wrapper} />
}
